const locale = {
	session_history_title:'Session History',
    session_history_desc:'This is your session history. You can use this list to see how, when, and by which devices your account has been accessed.',
    logout_from_all_session: 'Log out of all sessions',
    location:'Location',
    logged_in:'Logged In',
    ip:'IP',
    active_now: 'Active now',
    processing_logout_all_sessions: 'Processing : Log out of all sessions',
};

export default locale;
